<template>
  <div id="app">
    <TheNavbar />
    <div class="mt-4 mb-4">
      <router-view />
    </div>
  </div>
</template>

<script>
import { Component, Watch, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import TheNavbar from "@/components/TheNavbar.vue";

@Component({
  components: {
    TheNavbar,
  },
  computed: mapGetters(["currentUser"]),
})
export default class App extends Vue {
  created() {
    this.$store.dispatch("fetchUsers");
    this.$store.dispatch("fetchCampaigns");
    this.$store.dispatch("fetchChallenges");
  }

  @Watch("currentUser")
  changeUser() {
    this.$store.dispatch("fetchSubmissions");
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
